import { bindFunctions } from '@app/utils/class'
import classNames from 'classnames'
import * as React from 'react'
import './ExpandableContent.scss'

export interface IExpandableContentProps {
  children: React.ReactNode
  className?: string
  collapseHeight?: number
  style?: React.CSSProperties
}

export interface IExpandableContentState {
  contentHeight: number
  isExpanded: boolean
  isTooLong: boolean
}

export class ExpandableContent extends React.PureComponent<
  IExpandableContentProps,
  IExpandableContentState
> {
  private contentRef: React.RefObject<HTMLDivElement>

  constructor(props: IExpandableContentProps) {
    super(props)
    this.contentRef = React.createRef()

    this.state = {
      contentHeight: 0,
      isExpanded: false,
      isTooLong: false,
    }

    bindFunctions(this)
  }

  public componentDidMount() {
    this._measureContent()
  }

  public componentDidUpdate(prevProps: IExpandableContentProps) {
    if (
      prevProps.children !== this.props.children ||
      prevProps.collapseHeight !== this.props.collapseHeight
    ) {
      this._measureContent()
    }
  }

  public render() {
    const expandStyle: React.CSSProperties = {
      maxHeight:
        this.state.isTooLong && !this.state.isExpanded
          ? `${this.props.collapseHeight || 100}px`
          : `${this.state.contentHeight}px`,
      minHeight: this.state.isTooLong
        ? `${this.props.collapseHeight || 100}px`
        : undefined,
    }

    const contentClasses = classNames({
      'expandable-text': this.state.isTooLong,
    })

    return (
      <div className={this.props.className} style={this.props.style}>
        <div className={contentClasses} style={expandStyle}>
          <div ref={this.contentRef}>{this.props.children}</div>
        </div>
        {this.state.isTooLong && (
          <a className='text-primary' onClick={this._toggleExpand}>
            {this.state.isExpanded ? 'Hide' : 'See more...'}
          </a>
        )}
      </div>
    )
  }

  private _measureContent() {
    if (this.contentRef.current) {
      const collapseHeight = this.props.collapseHeight || 100
      if (this.contentRef.current.clientHeight > collapseHeight) {
        this.setState({
          contentHeight: this.contentRef.current.clientHeight,
          isTooLong: true,
        })
      } else {
        this.setState({
          contentHeight: this.contentRef.current.clientHeight,
          isTooLong: false,
        })
      }
    }
  }

  private _toggleExpand() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }
}
